"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChevronDownSmallIcon = void 0;
var React = require("react");
var IconWrapper_1 = require("../Icon/IconWrapper");
var ChevronDownSmallIcon = function (props) { return (React.createElement(IconWrapper_1.IconWrapper, __assign({}, props),
    React.createElement("path", { fill: "currentColor", d: "M14.7530611,12.2766478 C15.9888771,11.0326503 17,10.0091636 17,10.0022336 C17,9.99530372 16.7813757,9.76982058 16.5141692,9.50115989 L16.0283394,9.01268653 L14.2703168,10.7823337 L12.5122949,12.5519819 L10.7479715,10.775991 L8.98364813,9 L8.49182412,9.4949696 C8.22132081,9.76720268 8,9.99552848 8,10.0023614 C8,10.014535 12.4878975,14.5384615 12.4999747,14.5384615 C12.5033559,14.5384615 13.517245,13.5206452 14.7530611,12.2766478 Z" }))); };
exports.ChevronDownSmallIcon = ChevronDownSmallIcon;
